export const FILTER_RESULTS = "FILTER_RESULTS";
export const STATE_RESULTS = "STATE_RESULTS";
export const TYPE1026_RESULTS = "TYPE1026_RESULTS";
export const RIGHTS1026_RESULTS = "RIGHTS1026_RESULTS";
export const STORIES1026_RESULTS = "STORIES1026_RESULTS";
export const STRUCTURES1026_RESULTS = "STRUCTURES1026_RESULTS";
export const PHASES1026_RESULTS = "PHASES1026_RESULTS";
export const CONSTRUCTIONS1026_RESULTS = "CONSTRUCTIONS1026_RESULTS";
export const CONVERSIONS1026_RESULTS = "CONVERSIONS1026_RESULTS";
export const UNITS1026_RESULTS = "UNITS1026_RESULTS";
export const STYLE_RESULTS = "STYLE_RESULTS";
export const TYPE_RESULTS = "TYPE_RESULTS";
export const ADD_PROJECT = "ADD_PROJECT";
export const ADD_CONDO_INFO = "ADD_CONDO_INFO";
export const ADD_MASTER_ASSC_INFO = "ADD_MASTER_ASSC_INFO";
export const ADD_HOA_ASSC_INFO = "ADD_HOA_ASSC_INFO";
export const ADD_HOA_ASSC_ID = "ADD_HOA_ASSC_ID";
export const ADD_MASTER_ASSC_ID = "ADD_MASTER_ASSC_ID";
export const PHASE_STATUS_RESULTS = "PHASE_STATUS_RESULTS";
export const PHASE_TYPE_RESULTS = "PHASE_TYPE_RESULTS";
export const ADD_PERS_PROJECT_INFO = "ADD_PERS_PROJECT_INFO";
export const SUBMISSION_TYPES_RESULT = "SUBMISSION_TYPES_RESULT";
export const INITIATE_ADD_NEW_PROJECT = "INITIATE_ADD_NEW_PROJECT";

export const EDIT_PERS_INFO = "EDIT_PERS_INFO";
export const USER_DETAIL_RESULT = "USER_DETAIL_RESULT";
export const ROLE_DETAIL_RESULT = "ROLE_DETAIL_RESULT";

export const SET_DOC_TYPES_BY_FIELD = "SET_DOC_TYPES_BY_FIELD";
export const LENDER_ADD_PROJECT_INFO = "LENDER_ADD_PROJECT_INFO";
export const LENDER_ADD_PHASE_INFO = "LENDER_ADD_PHASE_INFO";
export const DOCUMENT_UPLOAD_RESULT = "DOCUMENT_UPLOAD_RESULT";
export const REQUEST_ID_RESULT = "REQUEST_ID_RESULT";
export const SET_REQUEST_TYPE_NAME = "SET_REQUEST_TYPE_NAME";
export const REQUEST_TYPE_ID_RESULT = "REQUEST_TYPE_ID_RESULT";
export const SET_REQUEST_SUBTYPES = "SET_REQUEST_SUBTYPES";
export const SET_REQUEST_SUBTYPE_ID_LOOKUP = "SET_REQUEST_SUBTYPE_ID_LOOKUP";
export const SET_REQUIRED_DOCUMENTS = "SET_REQUIRED_DOCUMENTS";
export const SET_REQUIRED_DOCUMENTS_WITH_COUNT = "SET_REQUIRED_DOCUMENTS_WITH_COUNT";
export const SET_OPTIONAL_DOCUMENTS = "SET_OPTIONAL_DOCUMENTS";
export const RESET_LENDER_REQUEST = "RESET_LENDER_REQUEST";
export const RESET_LENDER_REQUEST_PROJECT_INFO = "RESET_LENDER_REQUEST_PROJECT_INFO";
export const RESET_LENDER_REQUEST_PHASE_INFO = "RESET_LENDER_REQUEST_PHASE_INFO";
export const SET_EDITING_CHANGES = "SET_EDITING_CHANGES";
export const SET_REQUEST_SUBTYPE_LOOKUP = "SET_REQUEST_SUBTYPE_LOOKUP";
export const SET_PROJECT_FIELDS_MAP = "SET_PROJECT_FIELDS_MAP";
export const SET_PHASE_FIELDS_MAP = "SET_PHASE_FIELDS_MAP";
export const SET_DOCUMENT_RANKING_ID_TO_REQUEST_SUBTYPE_DOC_ID_MAP = "SET_DOCUMENT_RANKING_ID_TO_REQUEST_SUBTYPE_DOC_ID_MAP";
export const SET_REQUEST_SUBTYPE_TO_DOCUMENT_JUNCTION = "SET_REQUEST_SUBTYPE_TO_DOCUMENT_JUNCTION";
export const GET_EDITING_CHANGES = "GET_EDITING_CHANGES";
export const SET_ALL_DOC_TYPES_BY_ID = "SET_ALL_DOC_TYPES_BY_ID";
export const SET_REQUEST_STATUSES = "SET_REQUEST_STATUSES";

export const GET_CANNED_RESTRICTIONS_FOR_PROJECT = "GET_CANNED_RESTRICTIONS_FOR_PROJECT";
export const GET_CUSTOM_RESTRICTIONS_FOR_PROJECT = "GET_CUSTOM_RESTRICTIONS_FOR_PROJECT";
export const GET_CONDITIONS_FOR_PROJECT = "GET_CONDITIONS_FOR_PROJECT";
export const SET_REASON_CODES_TO_REQUEST_SUBTYPES = "SET_REASON_CODES_TO_REQUEST_SUBTYPES";

// Remove Delivery Restriction Request Action Types
export const REMOVE_DR_SET_STEP = "REMOVE_DR_SET_STEP";
export const REMOVE_DR_SET_RESTRICTIONS = "REMOVE_DR_SET_RESTRICTIONS";
export const REMOVE_DR_TOGGLE_RESTRICTION = "REMOVE_DR_TOGGLE_RESTRICTION";
export const REMOVE_DR_ADD_DOCUMENT = "REMOVE_DR_ADD_DOCUMENT";
export const REMOVE_DR_REMOVE_DOCUMENT = "REMOVE_DR_REMOVE_DOCUMENT";
export const REMOVE_DR_SET_NOTES = "REMOVE_DR_SET_NOTES";
export const REMOVE_DR_SET_PARTIAL_FAILURE = "REMOVE_DR_SET_PARTIAL_FAILURE";
export const REMOVE_DR_SUBMIT_REQUEST = "REMOVE_DR_SUBMIT_REQUEST";
export const REMOVE_DR_SUBMIT_SUCCESS = "REMOVE_DR_SUBMIT_SUCCESS";
export const REMOVE_DR_SUBMIT_FAILURE = "REMOVE_DR_SUBMIT_FAILURE";
export const REMOVE_DR_RESET_WIZARD = "REMOVE_DR_RESET_WIZARD";
export const REMOVE_DR_SUBMIT_REVIEW = "REMOVE_DR_SUBMIT_REVIEW";
export const REMOVE_DR_REVIEW_SUCCESS = "REMOVE_DR_REVIEW_SUCCESS";
export const REMOVE_DR_REVIEW_FAILURE = "REMOVE_DR_REVIEW_FAILURE";